import { DEFAULT_DEPARTMENT } from '../../shared/config/constants';

export const filterVacanciesByDepartment = (vacancies, departmentCode) => {
    if (!Array.isArray(vacancies) || departmentCode === DEFAULT_DEPARTMENT) {
        return vacancies;
    }

    return vacancies.filter(vacancy => vacancy.department.id === departmentCode);
};
